<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-removed-you">{{
  'ACTIVITY_YOU' | translate
}}</span>
<app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.user"
  [dataTestId]="'activity-removed-navigate-to-profile'"
></app-activities-navigate-profile>
{{ 'ACTIVITY_YOU_REMOVED_FILE' | translate }}
<b class="word-break" [attr.data-test-id]="'activity-removed-file-' + data.rowIndex">
  {{ data.value.entity_name }}
</b>
